'use client';

import { Box, Button, Image } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { useLocale } from 'next-intl';
import css from './header.module.css';
function Header() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'channelpartners');
  const partnerStackLink = 'https://application.partnerstack.com/application?company=doist&group=ambassadorslandingpage';
  const imagePath = `${process.env.NEXT_PUBLIC_BASE_URL}/static/channel-partners/banner.png`;
  return <Box className={cn(css.introSection, 'mbe-96 md-mbe-128')} data-sentry-element="Box" data-sentry-component="Header" data-sentry-source-file="header.tsx">
            <MainPageHeader size="sm" title={t('intro.title')} subtitle={t('intro.description')} buttonRow={[<Button key="1" href={partnerStackLink}>
                        {t('intro.cta')}
                    </Button>, <Button key="2" href="https://dash.partnerstack.com/login" variant="secondary">
                        {t('intro.dashboardLogin')}
                    </Button>]} mobileButtonRow={[<Button key="1" size="large" href={partnerStackLink}>
                        {t('intro.cta')}
                    </Button>]} mobileButtonBottom={<Button key="2" size="large" href="https://dash.partnerstack.com/login" variant="secondary">
                        {t('intro.dashboardLogin')}
                    </Button>} data-sentry-element="MainPageHeader" data-sentry-source-file="header.tsx" />
            <Image src={imagePath} width={1349} height={668} data-sentry-element="Image" data-sentry-source-file="header.tsx" />
        </Box>;
}
export { Header };